export default {
  data() {
    return {
      copy: false
    }
  },
  methods: {
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text

      // Avoid scrolling to bottom
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
      } catch (err) {
        /* eslint-disable no-console */
        console.error('Fallback: unable to copy', err)
      }

      document.body.removeChild(textArea)
    },
    copyClicked(text) {
      return this.copy === text
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text)
        return
      }
      navigator.clipboard.writeText(text)
      this.copy = text
    }
  }
}
